// File: src/pages/NearestPage.jsx
import { useNearest } from '../hooks/useMeetings';
import MeetingCard from '../components/MeetingCard';
import { toPersian } from '../data/constants';

export default function NearestPage() {
  const { nearest = [], loading, error, location, find } = useNearest();

  return (
    <div style={{ direction: 'rtl' }}>
      
      {/* انیمیشن پالس برای لودینگ موقعیت‌یابی */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.1); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* حالت اولیه: دکمه درخواست دسترسی به لوکیشن */}
      {!location && !loading && !error && (
        <button 
          onClick={find} 
          style={{
            width: '100%', 
            padding: '18px 20px', 
            marginBottom: 16,
            background: 'linear-gradient(135deg, #0369a1, #0ea5e9)',
            border: 'none', 
            borderRadius: 16,
            fontSize: 14, 
            fontWeight: 800, 
            color: '#ffffff', 
            cursor: 'pointer',
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: 10,
            boxShadow: '0 4px 12px rgba(14, 165, 233, 0.2)',
            transition: 'opacity 0.2s'
          }}
          onMouseOver={e => e.currentTarget.style.opacity = '0.9'}
          onMouseOut={e => e.currentTarget.style.opacity = '1'}
        >
          🧭 یافتن نزدیک‌ترین جلسات با GPS
        </button>
      )}

      {/* وضعیت در حال دریافت موقعیت جغرافیایی */}
      {loading && (
        <div style={{ padding: '60px 0', textAlign: 'center' }}>
          <div style={{ 
            fontSize: 36, 
            marginBottom: 12, 
            display: 'inline-block',
            animation: 'pulse 1.5s ease infinite' 
          }}>
            🧭
          </div>
          <p style={{ color: 'var(--text2)', fontSize: 13, fontWeight: 600 }}>
            در حال دریافت موقعیت مکانی شما...
          </p>
        </div>
      )}

      {/* نمایش خطاها با رنگ‌بندی ایمن بر اساس کنتراست تم */}
      {error && (
        <div style={{ 
          background: 'rgba(239, 68, 68, 0.06)', 
          border: '1px solid rgba(239, 68, 68, 0.18)',
          borderRadius: 14, 
          padding: 16, 
          textAlign: 'center',
          marginBottom: 16
        }}>
          <p style={{ color: 'var(--text)', fontSize: 13, marginBottom: 12, fontWeight: 600 }}>
            ⚠️ {error}
          </p>
          <button 
            onClick={find} 
            style={{ 
              fontSize: 12, 
              color: '#ef4444', 
              fontWeight: 700,
              background: 'none', 
              border: 'none', 
              textDecoration: 'underline', 
              cursor: 'pointer' 
            }}
          >
            تلاش مجدد
          </button>
        </div>
      )}

      {/* نمایش نتایج پس از موفقیت در دریافت موقعیت */}
      {location && !loading && (
        <>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            gap: 8, 
            marginBottom: 16,
            fontSize: 12, 
            color: '#10b981',
            fontWeight: 700
          }}>
            <span>✅ موقعیت دریافت شد · {toPersian(nearest.length)} جلسه نزدیک شما</span>
            
            <button 
              onClick={find} 
              title="به‌روزرسانی موقعیت"
              style={{ 
                fontSize: 12, 
                color: 'var(--text2)',
                padding: '6px 10px', 
                background: 'var(--bg2)',
                border: '1px solid var(--border)', 
                borderRadius: 8,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.15s'
              }}
              onMouseOver={e => e.currentTarget.style.borderColor = 'var(--accent)'}
              onMouseOut={e => e.currentTarget.style.borderColor = 'var(--border)'}
            >
              🔄 بازخوانی
            </button>
          </div>

          {nearest.length === 0 ? (
            <div style={{ padding: '60px 20px', textAlign: 'center', opacity: 0.4 }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📍</div>
              <p style={{ color: 'var(--text2)', fontSize: 13, fontWeight: 700 }}>
                هیچ جلسه‌ای در محدوده نزدیک شما یافت نشد.
              </p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {nearest.map((m, i) => (
                <div key={m.id} style={{ animation: `slideUp .3s ease ${Math.min(i, 8) * 0.05}s both` }}>
                  <MeetingCard meeting={m} />
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}